// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"161":"aeb30847","179":"d3b379fb","224":"268ad6c2","543":"11baad97","961":"96c9b3c4"}[chunkId] + ".js";
};